export class Model {
    constructor(data?: object) {
        Object.assign(this, data);
    }

}
